// Basic Jquery random
$(document).ready(function () {
  $('div#newsletter-signup').insertAfter('.footer-block.footer-block__logo');
  $('br').attr('aria-hidden', 'true');
  $('hr').attr('aria-hidden', 'true');
  $('.footer__policy-links').insertAfter('.footer__copyright');
  $('.slideshow__slide.grid__item').removeAttr('aria-hidden');
  setTimeout(function () {
    $('.slideshow__slide.grid__item').removeAttr('aria-hidden');
  }, 2000);
  setTimeout(function () {
    $('.slideshow__slide.grid__item').removeAttr('aria-hidden');
    $('a[href="/products/raspberry-blondie-batter-16oz-jar"] button.button.button--small').attr(
      'aria-label',
      'Learn More About the Coconut Cult in Flavor',
    );
    $('.product-selection__expand-product svg')
      .attr('role', 'button')
      .attr('aria-label', 'Add Product Quantity to Bundle, After adding, the focus returns to the top of the section.');
    $('.product-selection__add-remove-product').each(function () {
      $(this).find('.control:first svg').attr('aria-label', 'Decrease Quantity By 1').attr('role', 'button');

      $(this).find('.control:last svg').attr('aria-label', 'Increase Quantity By 1').attr('role', 'button');
    });
  }, 1000);
});

// Product Selection Accessibility
$(document).ready(function () {
  $(document).on(
    'click',
    '.product-selection__expand-product svg,.product-selection__add-remove-product .control svg',
    function () {
      setTimeout(function () {
        $('.product-selection__expand-product svg')
          .attr('role', 'button')
          .attr(
            'aria-label',
            'Add Product Quantity to Bundle, After adding, the focus returns to the top of the section.',
          );

        $('.product-selection__add-remove-product').each(function () {
          $(this).find('.control:first svg').attr('aria-label', 'Decrease Quantity By 1').attr('role', 'button');

          $(this).find('.control:last svg').attr('aria-label', 'Increase Quantity By 1').attr('role', 'button');
        });
      }, 1000);
    },
  );
});

// Text For Cart
$(document).ready(function () {
  setTimeout(function () {
    $('a.button.button--primary.add-to-bundle.go-to-shop').text('Build Your Bundle');
  }, 500);
});
// Funtionailty to go collection
$(document).ready(function () {
  $('.button--primary.add-to-bundle').on('click', function (event) {
    event.preventDefault(); // Prevents the default link behavior

    if ($(this).hasClass('go-to-shop')) {
      window.location.href = '/collections/all'; // Redirects to the desired URL
    }
  });
});

// Email and phone number labels
$(document).ready(function () {
  function handleContactLinks() {
    $('a[href^="mailto:"], a[href^="tel:"]').each(function () {
      var $link = $(this);
      var href = $link.attr('href');
      var linkText = $.trim($link.text());

      if (href.startsWith('mailto:')) {
        $link.attr('aria-label', 'Email Address: ' + linkText);
      } else if (href.startsWith('tel:')) {
        // remove Tel: or Phone:
        linkText = linkText.replace(/^(Tel:|Phone:)\s*/i, '');
        $link.attr('aria-label', 'Phone number: ' + linkText);
      }
    });
  }

  handleContactLinks();
});

// Accessibility Enhancements for Third-Party Links
$(document).ready(function () {
  var excludedLinks = [];

  function isThirdParty(url) {
    try {
      var linkHost = new URL(url, window.location.origin).hostname;
      var currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch (e) {
      return false;
    }
  }

  function handleExternalLinks() {
    $('a').each(function () {
      var $link = $(this);
      var href = $link.attr('href');

      // ← SKIP OKENDO LINK (NO CLASS NEEDED)
      if (
        !href ||
        !isThirdParty(href) ||
        excludedLinks.includes(href) ||
        href.includes('okendo.reviews') ||
        $link.hasClass('oke-w-writeReview')
      )
        return;

      // Always open in new tab
      $link.attr('target', '_blank');
      $link.attr('rel', 'noopener noreferrer');

      if (!$link.attr('aria-label')) {
        var existingText = $.trim($link.text());
        var ariaLabel = existingText
          ? existingText + ', This link will open in a new tab'
          : 'This link will open in a new tab';
        $link.attr('aria-label', ariaLabel);
      }

      var $img = $link.find('img, svg').first();
      if ($img.length && !$img.attr('alt')) {
        $img.attr('alt', 'This link will open in a new tab');
      }
    });
  }

  handleExternalLinks();

  var observer = new MutationObserver(function () {
    handleExternalLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// Product Description Tabs
$(document).ready(function () {
  $('.tab-button.button').on('click', function () {
    // Remove aria-selected="true" from all buttons
    $('.tab-button.button').attr('aria-selected', 'false');

    // Check if the clicked button has the "button--primary" class
    if ($(this).hasClass('button--primary')) {
      $(this).attr('aria-selected', 'true');
    }
  });
});

// Heading Sequence
$(document).ready(function () {
  $('h3.card__heading.h2').each(function () {
    var $h3 = $(this);
    var attributes = {};

    $.each(this.attributes, function () {
      if (this.specified) {
        attributes[this.name] = this.value;
      }
    });

    var $h2 = $('<h2>', attributes).html($h3.html());

    $h3.replaceWith($h2);
  });
});

// Adding label to Build Bundle Product
$(document).ready(function () {
  $('.slideshow__text.banner__box.content-container').each(function () {
    // Find the h2.h3 inside this container and get its trimmed text
    var trimmedText = $(this).find('h2.h3').text().trim();

    // Build the aria-label string
    var ariaLabel = 'Build Your Bundle of ' + trimmedText;

    // Find the button and set the aria-label
    $(this).find('a.button.button--primary.add-to-bundle.go-to-shop').attr('aria-label', ariaLabel);
  });
});

// Fixing Reading Sequence
$(document).ready(function () {
  var firstLi = $('.home-collage ul li').first();
  var firstSection = firstLi.find('.multicolumn-card.content-container').first();
  var imageWrapper = firstSection.children('.multicolumn-card__image-wrapper').first();
  var info = firstSection.children('.multicolumn-card__info').first();

  if (imageWrapper.length && info.length) {
    imageWrapper.insertAfter(info);
  }
});

// Adding label to add to cart button
$(document).ready(function () {
  $('.slideshow__text.banner__box.content-container').each(function () {
    // Find the h2.h3 inside this container and get its trimmed text
    var trimmedText = $(this).find('h2.h3').text().trim();

    // Build the aria-label string
    var ariaLabel = 'Add to Cart ' + trimmedText;

    // Find the button and set the aria-label
    $(this).find('a.button.button--primary').attr('aria-label', ariaLabel);
  });
});
$(document).ready(function () {
  $('.announcement-bar').each(function () {
    var $bar = $(this);
    var $children = $bar.children().filter(function () {
      return this.nodeType === 1; // Only element nodes
    });

    if ($children.length === 1 && $children.is('button')) {
      // Remove all aria-label attributes inside this bar
      $bar.find('[aria-label]').removeAttr('aria-label');

      // Add aria-hidden="true" to the announcement bar
      $bar.remove();
    }
  });
});
//   $(document).ready(function() {
//     setTimeout(function() {
//       // Select all anchor tags that contain a button
//       $('a:has(> button.button--small)').each(function() {
//         const anchor = this;
//         const button = $(this).find('button.button--small')[0];

//         // Initial label set
//         updateAriaLabel(anchor, button);

//         // Create MutationObserver for href changes
//         const observer = new MutationObserver(function(mutations) {
//           mutations.forEach(function(mutation) {
//             if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
//               updateAriaLabel(anchor, button);
//             }
//           });
//         });

//         observer.observe(anchor, {
//           attributes: true,
//           attributeFilter: ['href']
//         });
//       });

//       function updateAriaLabel(anchor, button) {
//         const href = anchor.getAttribute('href');
//         if (!href) return;

//         const slug = href.split('/').pop(); // get the last part of the URL

//         const readableName = slug
//           .replace(/-/g, ' ')                   // Replace hyphens with spaces
//           .replace(/\d+oz.*$/, '')             // Remove size like '16oz-jar'
//           .trim()
//           .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize first letters

//         button.setAttribute('aria-label', 'Learn More about ' + readableName);
//       }
//     }, 500); // 0.5 second delay
//   });
//     $(document).ready(function() {
//     setTimeout(function() {
//       $('.accouncement-bar__closer').attr('aria-label', 'Close bar');
//     }, 500);
//   });

//   $(document).ready(function() {
//   setTimeout(function() {
//     $('.slideshow__text').each(function() {
//       const $container = $(this);
//       const headingText = $container.find('.banner__heading a').text().trim();
//       const button = $container.find('.add-to-bundle');

//       const buttonText = button.text().trim();
//       const newAriaLabel = `${buttonText} ${headingText}`;

//       button.attr('aria-label', newAriaLabel);
//     });
//   }, 500); // Delay for 500ms
// });

$(document).ready(function () {
  setTimeout(function () {
    // Inject style for .button.button--small
    const styleTag = `<style>
      .button.button--small {
        margin-top: 40rem !important;
      }
    </style>`;
    $('head').append(styleTag);

    // Process each anchor with a small button
    $('a:has(> button.button--small)').each(function () {
      const anchor = this;
      const $anchor = $(anchor);
      const $button = $anchor.find('button.button--small');

      if ($button.length === 0) return;

      // Initial label set and modification
      updateAriaLabelAndModify(anchor);

      // Observe href changes
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
            updateAriaLabelAndModify(anchor);
          }
        });
      });

      observer.observe(anchor, {
        attributes: true,
        attributeFilter: ['href'],
      });

      function updateAriaLabelAndModify(anchorEl) {
        const $anchor = $(anchorEl);
        const href = $anchor.attr('href');
        if (!href) return;

        const slug = href.split('/').pop();

        const readableName = slug
          .replace(/-/g, ' ')
          .replace(/\d+oz.*$/, '')
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase());

        const labelText = 'Learn More about ' + readableName;

        // Replace <button> with <span> if not already done
        let $buttonOrSpan = $anchor.find('button.button--small, span.button--small').first();
        if ($buttonOrSpan.length && $buttonOrSpan.prop('tagName').toLowerCase() === 'button') {
          const $span = $('<span>')
            .addClass($buttonOrSpan.attr('class'))
            .attr('aria-label', labelText)
            .text($buttonOrSpan.text());
          $buttonOrSpan.replaceWith($span);
          $buttonOrSpan = $span;
        } else {
          $buttonOrSpan.attr('aria-label', labelText);
        }

        // Handle image: move and set unique alt
        const $imgInAnchor = $anchor.find('img').first();
        if ($imgInAnchor.length) {
          const $clonedImg = $imgInAnchor.clone();
          const altText = readableName + ' Coconut Cult';
          $clonedImg.attr('alt', altText);
          $anchor.before($clonedImg);
          $imgInAnchor.remove();
        } else {
          // If image already moved outside, still update its alt if present
          const $prevImg = $anchor.prev('img');
          if ($prevImg.length) {
            const newAlt = readableName + ' Coconut Cult';
            $prevImg.attr('alt', newAlt);
          }
        }
      }
    });

    $('.slideshow__text').each(function () {
      const $container = $(this);
      const headingText = $container.find('.banner__heading a').text().trim();
      const $button = $container.find('.add-to-bundle');

      const buttonText = $button.text().trim();
      const newAriaLabel = `${buttonText} ${headingText}`;

      $button.attr('aria-label', newAriaLabel);
    });
  }, 500);
});

// svg accessibility - hide from screen readers
$(document).ready(function () {
  $('svg').each(function () {
    const hasTitle = $(this).find('title').length > 0;
    const hasAriaLabel = $(this).attr('aria-label');
    const hasAriaLabelledBy = $(this).attr('aria-labelledby');
    const isImageRole = $(this).attr('role') === 'img';

    if (!hasTitle && !hasAriaLabel && !hasAriaLabelledBy && !isImageRole) {
      $(this).attr('aria-hidden', 'true');
    }
  });
});

// Add role="button" and aria-haspopup="dialog" to Add to Cart buttons on product pages
$(document).ready(function () {
  if (window.location.pathname.includes('/products/')) {
    $('.add-to-cart').attr('role', 'button').attr('aria-haspopup', 'dialog');
  }
});

// add to cart drawer accessibility and focus management
$(document).ready(function () {
  // Add role="button" and aria-haspopup="dialog" to add-to-cart buttons
  if (window.location.pathname.includes('/products/')) {
    $('.add-to-cart').attr({
      role: 'button',
      'aria-haspopup': 'dialog',
    });
  }

  let lastClickedButton = null;
  let focusBackOnAddToCart = false; // flag to track Add to Cart source

  // Handle click on add-to-cart
  $(document).on('click', '.add-to-cart', function () {
    lastClickedButton = this;
    focusBackOnAddToCart = true; // only true when Add to Cart clicked

    // Small delay to let Shopify JS open the drawer
    setTimeout(function () {
      const closeButton = $('#cart-drawer .drawer__close');
      if (closeButton.length) {
        closeButton.focus();
      }
    }, 100);
  });

  // Handle click on drawer close button
  $(document).on('click', '#cart-drawer .drawer__close', function () {
    if (focusBackOnAddToCart && lastClickedButton) {
      $(lastClickedButton).focus();
    }
    // Reset after closing
    lastClickedButton = null;
    focusBackOnAddToCart = false;
  });

  // Handle Escape key to close drawer and return focus
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      const drawer = $('#cart-drawer');
      if (drawer.hasClass('active')) {
        drawer.find('.drawer__close').click();
      }
    }
  });
});

// Replace "Add to Cart" with "Build Your Bundle"
$(document).ready(function () {
  function updateAria($link) {
    var aria = $link.attr('aria-label');
    if (aria && aria.startsWith('Add to Cart')) {
      $link.attr('aria-label', aria.replace(/^Add to Cart/, 'Build Your Bundle'));
    }
  }

  // Existing elements
  $('a.button.button--primary.go-to-shop.go-to-shop').each(function () {
    updateAria($(this));
  });

  // Observe new elements dynamically
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if ($(node).is('a.button.button--primary.go-to-shop.go-to-shop')) {
          updateAria($(node));
        }
        $(node)
          .find('a.button.button--primary.go-to-shop.go-to-shop')
          .each(function () {
            updateAria($(this));
          });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Remove aria-label from spans unused
  (function () {
    const selector = 'span[aria-label]';

    function removeAria(node) {
      if (node.hasAttribute && node.hasAttribute('aria-label')) {
        node.removeAttribute('aria-label');
      }
    }

    document.querySelectorAll(selector).forEach(removeAria);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.target.tagName === 'SPAN') {
          removeAria(mutation.target);
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // element
            removeAria(node);
            node.querySelectorAll && node.querySelectorAll(selector).forEach(removeAria);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label'],
    });
  })();
});
